var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1694488889600,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 37181,
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.008 786.752c-52.928 0-96-43.072-96-96s43.072-96 96-96 96 43.072 96 96-43.072 96-96 96z m0-128c-17.632 0-32 14.336-32 32s14.368 32 32 32 32-14.336 32-32-14.368-32-32-32z",
    "p-id": 37182,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416.096 927.072H284.224c-159.936 0-186.912-59.232-186.912-192v-140.8c0-74.272 14.304-96.256 70.72-150.976l327.04-319.904C531.648 87.904 600.96 88 637.376 123.296l263.072 256.032c18.336 17.792 28.864 43.552 28.864 70.656 0 27.296-10.656 53.28-29.248 71.264L610.048 815.84c-65.504 64.576-112.832 111.232-193.952 111.232zM566.24 159.488c-10.496 0-20.16 3.52-26.528 9.696L212.672 489.12c-49.952 48.48-51.36 54.528-51.36 105.152v140.8c0 110.272 8.352 128 122.912 128h131.872c52.672 0 83.744-28.48 148.992-92.8l26.656-26.144 263.232-268.256c6.784-6.592 10.336-15.808 10.336-25.888 0-9.888-3.424-18.88-9.472-24.736L592.768 169.216c-6.336-6.176-16.032-9.728-26.528-9.728z",
    "p-id": 37183,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9743ceb7c8f0d2b13544989785267cc0.svg";
export { ForwardRef as ReactComponent };